import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { ClientLogger } from 'bernie-client';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';

import { HotelViewModel } from 'models';

import { UitkCarousel } from 'uitk-react-carousel';
import { UitkPlaceholderCard } from 'uitk-react-cards';

import { Lazy } from 'components/common/lazy/lazy';
import { Listing } from 'components/search/listing';

export interface SimilarHotelsProps extends LocalizedComponentProps {
  similarHotels: HotelViewModel[];
  analytics?: AnalyticsStore;
  isRefreshedHISLayout?: boolean;
}

@withLocalization
export class SimilarHotels extends React.Component<SimilarHotelsProps> {
  private logger = ClientLogger.getLoggerWithIdentifier('pwa.component.similar-hotels');
  constructor(props) {
    super(props);
    this.fireImpressionBeacon = this.fireImpressionBeacon.bind(this);
  }

  private fireImpressionBeacon(index: number) {
    if (this.props.similarHotels[index].travelAd && this.props.similarHotels[index].travelAd.carouselImpressionTrackingUrl) {
      const impressionUrl = this.props.similarHotels[index].travelAd.carouselImpressionTrackingUrl;
      fetch(impressionUrl).catch(() => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.WARN, 'TRAVELAD_IMPRESSION_FAILURE'), ' URL=[' + impressionUrl + ']');
      });
    }
  }

  public render() {
    const { analytics, l10n, similarHotels } = this.props;

    if (!similarHotels || similarHotels.length === 0) {
      return null;
    }

    const carouselName = 'HIS-similar-hotels';
    const recommenderCarouselProps = {
      carouselName,
      itemsVisible: { lg: 3, md: 2, sm: 1 },
      pageBy: 1,
      peekWidth: 12,
      className: 'all-x-margin-six xl-x-margin-zero m-x-margin-zero s-x-margin-three all-t-margin-six',
      headline: l10n.formatText('hotels.infosite.recommenderCarousel.headline'),
      analytics: analytics.setupTracker(carouselName, 'Carousel interaction'),
      buttonText: {
        nextButton: l10n.formatText('carousel.nextItem'),
        prevButton: l10n.formatText('carousel.previousItem')
      },
      wrapItems: false
    };

    const placeholderCarouselProps = { ...recommenderCarouselProps, itemsVisible: { lg: 2, md: 2, sm: 1 } };

    return (
      <Lazy>
        <Lazy.Placeholder>
          <UitkCarousel {...placeholderCarouselProps}>
            <li>
              <UitkPlaceholderCard />
            </li>
            <li>
              <UitkPlaceholderCard />
            </li>
          </UitkCarousel>
        </Lazy.Placeholder>
        <Lazy.Loaded>
          <div className={this.props.isRefreshedHISLayout ? 'all-x-padding-four' : ''}>
            <UitkCarousel itemViewedCallback={this.fireImpressionBeacon} {...recommenderCarouselProps}>
              {similarHotels.map((hotel, index) => {
                hotel.primaryCardMessagingModel = null;
                if (hotel.travelAd) {
                  hotel.travelAd.carouselImpressionTrackingUrl = hotel.travelAd.impressionTrackingUrl;
                  hotel.travelAd.impressionTrackingUrl = null;
                }

                return (
                  <Listing
                    disableGallery={true}
                    analytics={analytics}
                    className="listing uitk-carousel-item uitk-flex-grow-1"
                    defaultListingOnly={true}
                    key={`carousel-item-${index}`}
                    model={hotel}
                    referralObject={{ navigation: { rfrr: `hotels.infosite.HIS-similar-hotels.${index}` } }}
                  />
                );
              })}
            </UitkCarousel>
            {this.props.isRefreshedHISLayout && <hr />}
          </div>
        </Lazy.Loaded>
      </Lazy>
    );
  }
}
